// extracted by mini-css-extract-plugin
export default {"fields":"_3IAUsw","error":"_43ainU","smallDesc":"Hxb5rV"};